export const workersSetFieldNames = {
  master: 'masterId',
  executer: 'executorId',
  address: 'addressId',
  service: 'serviceId',
};

export const docFieldNames = {
  docDate: 'docDate',
  docType: 'typeId',
  docName: 'name',
  file: 'file',
};

export const fieldNames = {
  ...docFieldNames,
  ...workersSetFieldNames,
};
